import { categoryHelper } from '~/lib/category/helper';
import type { CategorySchema } from '~/types/schema';
import { ContentTypes } from '~/types/adamTypes';

export enum AssessmentFormSelectorTypes {
  Disciplines = 'disciplines',
  Chapters = 'chapters',
  Forbidden = 'forbidden',
}

// SET VIEW FOR ASSESSMENTS
export const useCategoryAssessmentFormSelectorTypes = (
  category: CategorySchema
) => {
  const helper = categoryHelper();

  const getSelectorType = (): AssessmentFormSelectorTypes => {
    switch (category.contentType) {
      case ContentTypes.CourseAndQuiz:
      case ContentTypes.Exam:
      case ContentTypes.Testing:
      case ContentTypes.Training:
        return AssessmentFormSelectorTypes.Disciplines;
      case ContentTypes.SuperDiscipline:
      case ContentTypes.InterDisciplineFocusOn:
      case ContentTypes.Discipline:
      case ContentTypes.SubDiscipline:
      case ContentTypes.DisciplineSection:
      case ContentTypes.InterDiscipline:
      case ContentTypes.DisciplineSubSection:
      case ContentTypes.SubChapter:
        if (
          helper.hasCategories(category) &&
          helper.hasOnlyCategoryWithTypes(category, [
            ContentTypes.SubDiscipline,
            ContentTypes.Extra,
            ContentTypes.SubChapter,
            ContentTypes.Chapter,
          ])
        ) {
          return AssessmentFormSelectorTypes.Chapters;
        } else if (
          helper.hasCategories(category) &&
          helper.hasOneOfThisCategory(category, [
            ContentTypes.DisciplineSection,
            ContentTypes.SubDiscipline,
            ContentTypes.Extra,
            ContentTypes.Discipline,
          ])
        ) {
          return AssessmentFormSelectorTypes.Disciplines;
        } else if (helper.hasDifferentCategories(category)) {
          return AssessmentFormSelectorTypes.Chapters;
        } else if (
          helper.hasOnlyCategoryWithType(category, ContentTypes.Annals) ||
          helper.hasOnlyCategoryWithType(category, ContentTypes.Chapter) ||
          helper.hasOnlyCategoryWithType(category, ContentTypes.Essential)
        ) {
          return AssessmentFormSelectorTypes.Chapters;
        } else if (
          helper.hasOnlyPostsWithType(category, PostTypes.ContentPDF)
        ) {
          // normaly not used because previous actions already open a modal
          return AssessmentFormSelectorTypes.Forbidden;
        } else {
          return AssessmentFormSelectorTypes.Chapters;
        }
      case ContentTypes.Practice:
      case ContentTypes.Extra:
      case ContentTypes.Chapter:
      case ContentTypes.VideoRecorder:
      case ContentTypes.VideoRecorderResult:
        return AssessmentFormSelectorTypes.Forbidden;
    }
  };
  const selectorType = getSelectorType();

  return {
    selectorType,
  };
};
